import { Result } from 'src_common/common/mobx-utils/Form2/FormModel';

type GetTranslationType = (id: string, defaultText: string) => string;

const GENERIC_REGEXP = /^[a-zA-Z0-9][a-zA-Z0-9\- ]{0,10}[a-zA-Z0-9]$/;
const UK_REGEXP = /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s*\d[A-Za-z]{2}$/;

export const validatePostCode =
    (getTranslation: GetTranslationType, ukOnly: boolean = false) =>
    (value: string): Result<string> => {
        const REGEXP = ukOnly ? UK_REGEXP : GENERIC_REGEXP;
        if (!REGEXP.test(value)) {
            return Result.createError(getTranslation('errors.postCode', 'Please enter valid post code'));
        }
        return Result.createOk(value);
    };
